export default class {
  constructor($uibModalInstance, view) {
    'ngInject';
    this.$uibModalInstance = $uibModalInstance;
    this.view = view;
  }

  delete() {
    this.$uibModalInstance.close();
  }

  cancel() {
    this.$uibModalInstance.dismiss();
  }
}